import React from 'react';
import { whyChooseUsDetailed } from '../mock';
import { Briefcase, DollarSign, Zap, LifeBuoy, ChevronLeft, ChevronRight } from 'lucide-react';
import useEmblaCarousel from 'embla-carousel-react';
import Autoplay from 'embla-carousel-autoplay';

const iconComponents = {
  Briefcase,
  DollarSign,
  Zap,
  LifeBuoy
};

const WhyChooseUsSection = () => {
  const [emblaRef, emblaApi] = useEmblaCarousel(
    { loop: true, align: 'start' },
    [Autoplay({ delay: 3500, stopOnInteraction: false })]
  );

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-white relative overflow-hidden">
      {/* Decorative Image - Modern Abstract */}
      <div className="absolute right-0 top-1/2 -translate-y-1/2 w-1/3 h-full opacity-10 hidden lg:block">
        <img 
          src="https://images.unsplash.com/photo-1710244182004-1c708b3f146d" 
          alt="Modern abstract shapes" 
          className="w-full h-full object-cover"
        />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-12">
          <p className="text-sm font-semibold text-[#F97316] uppercase tracking-wide mb-2" style={{ textShadow: '0 2px 4px rgba(0,0,0,0.2)' }}>
            Why Choose Us
          </p>
          <h2 className="text-4xl md:text-5xl font-bold text-[#012169] mb-4">
            Why Businesses Trust Our Trademark Registration Service
          </h2>
          <p className="text-base text-gray-600 max-w-3xl mx-auto">
            10,000+ successful USPTO trademark filings with 98% approval rate. Licensed IP attorneys, transparent pricing, and comprehensive trademark protection from search to federal registration.
          </p>
        </div>

        {/* Desktop Grid */}
<div className="hidden md:grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {whyChooseUsDetailed.map((feature) => {
            const IconComponent = iconComponents[feature.icon];
            return (
              <div
                key={feature.id}
                className="group bg-white p-8 rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border-2 border-transparent hover:border-[#F97316] flex flex-col min-h-[280px]"
              >
                <div className="w-16 h-16 bg-gradient-to-br from-[#FFD700] to-[#F97316] rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 flex-shrink-0">
                  <IconComponent className="h-8 w-8 text-white" />
                </div>
                <h3 className="text-base font-bold text-[#012169] mb-3 flex-shrink-0">
                  {feature.title}
                </h3>
                <p className="text-gray-600 leading-relaxed text-sm">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Mobile Slider */}
        <div className="md:hidden relative">
          <div className="overflow-hidden px-12" ref={emblaRef}>
            <div className="flex gap-4">
              {whyChooseUsDetailed.map((feature) => {
                const IconComponent = iconComponents[feature.icon];
                return (
                  <div key={feature.id} className="flex-[0_0_100%] min-w-0">
                    <div className="bg-white p-8 rounded-xl shadow-lg border-2 border-gray-100 flex flex-col min-h-[280px]">
                      <div className="w-16 h-16 bg-gradient-to-br from-[#FFD700] to-[#F97316] rounded-xl flex items-center justify-center mb-6 flex-shrink-0">
                        <IconComponent className="h-8 w-8 text-white" />
                      </div>
                      <h3 className="text-base font-bold text-[#012169] mb-3 flex-shrink-0">
                        {feature.title}
                      </h3>
                      <p className="text-gray-600 leading-relaxed text-sm">
                        {feature.description}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Navigation Arrows */}
          <button
            onClick={() => emblaApi?.scrollPrev()}
            className="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-white hover:bg-[#F97316] shadow-lg rounded-full p-2 transition-colors duration-300"
            aria-label="Previous"
          >
            <ChevronLeft className="h-5 w-5 text-[#012169]" />
          </button>
          <button
            onClick={() => emblaApi?.scrollNext()}
            className="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-white hover:bg-[#F97316] shadow-lg rounded-full p-2 transition-colors duration-300"
            aria-label="Next"
          >
            <ChevronRight className="h-5 w-5 text-[#012169]" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUsSection;